import gql from "graphql-tag";

export const MY_TIMESHEET_PROJECTS_SUBSCRIPTION = gql`
  subscription MySheetProjectsSubscription {
    MySheetProjectsSubscription
  }
`;
